import { useCallback } from 'react';

import { getCountry } from '@iwIntlProvider/CountryProvider';
import { GoogleTagManager, tracking } from '@iwoca/frontend-tracking-library';
import { IconAngleRight } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { REQUEST_CHANGE_ROUTER } from '@iwRouter/IwRouter.actions';
import { PaymentCardSVG } from '@svgComponents/paymentCardSVG/PaymentCardSVG';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import messages from './RepayEarlyForFree.messages';
import { EARLY_REPAYMENT_ACCOUNT_ID } from '../../../../earlyRepayment/EarlyRepayment.actions';
import DashboardCTA from '../../../dashboardComponents/DashboardCTA/DashboardCTA';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    addAccountIdToEarlyRepayment: (accountId: string) =>
        dispatch({
            type: EARLY_REPAYMENT_ACCOUNT_ID,
            accountId
        }),
    goToEarlyRepayment: () =>
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location: { pathname: '/repayment/' }
        })
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

type Props = {
    className?: string;
} & PropsFromRedux;

const RepayEarlyForFree = ({
    accountId,
    addAccountIdToEarlyRepayment,
    goToEarlyRepayment,
    className
}: { accountId: string } & Props) => {
    const trackAndGoToEarlyRepayment = useCallback(() => {
        GoogleTagManager.trackClick({
            identifier: 'Make early repayment button'
        });

        tracking.ampli.earlyRepaymentClicked({
            account_id: accountId
        });
        if (getCountry() === 'DE') {
            tracking.ampli.dashboardActionClicked({
                name: messages.ctaText.defaultMessage
            });
        }

        addAccountIdToEarlyRepayment(accountId);
        goToEarlyRepayment();
    }, [accountId, addAccountIdToEarlyRepayment, goToEarlyRepayment]);

    return (
        <DashboardCTA
            title={<FormattedMessage {...messages.title} />}
            icon={<PaymentCardSVG />}
            className={className}
            description={<FormattedMessage {...messages.description} />}
            data-testid="repay-early-for-free"
            cta={
                <Button
                    variant="tertiary"
                    data-testid="make-repayment-action-button"
                    onClick={trackAndGoToEarlyRepayment}
                    className="p-0 text-s hover:!bg-transparent hover:underline"
                >
                    <FormattedMessage {...messages.ctaText} />
                    <IconAngleRight />
                </Button>
            }
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(RepayEarlyForFree);
